// Assigned by the backend at request time: 'primary' is a dimension a person
// slices the business by, 'secondary' is a real column that does not belong in
// the first row of chips (keys, codes, the accountant's account columns).
export type FilterTier = 'primary' | 'secondary';

export interface DateRangeFilter {
  type: 'daterange';
  id: string;
  col: string;
  label: string;
  tables: string[];
  is_json: true;
  min?: string;
  max?: string;
  tier?: FilterTier;
}

export interface MultiSelectFilter {
  type: 'multiselect';
  id: string;
  col: string;
  label: string;
  tables: string[];
  is_json: true;
  options: string[];
  /**
   * Values are not in `options`: the dropdown asks /api/dashboard/filter-options
   * for them when it opens. Some columns hold 125K distinct values.
   */
  options_lazy?: boolean;
  /** How many distinct values the column holds, when the server knows already. */
  option_count?: number | null;
  tier?: FilterTier;
}

export type Filter = DateRangeFilter | MultiSelectFilter;

export interface DateRangeValue { from: string; to: string }
export type FilterValue = DateRangeValue | string[];

export interface ActiveFilters { [id: string]: FilterValue }

export function filterKey(f: Filter): string {
  return f.id;
}

export function buildFilterPayload(filters: Filter[], active: ActiveFilters): object[] {
  const payload: object[] = [];
  for (const f of filters) {
    const val = active[f.id];
    if (!val) continue;

    const base = { id: f.id, col: f.col, type: f.type, tables: f.tables };

    if (f.type === 'daterange') {
      const dv = val as DateRangeValue;
      if (dv.from || dv.to) payload.push({ ...base, value: dv });
    } else {
      const mv = val as string[];
      if (mv.length > 0) payload.push({ ...base, value: mv });
    }
  }
  return payload;
}
